<template>
  <div
    :class="containerClass"
  >
    <v-toolbar
      :class="customClass"
      color="primary"
      :dark="true"
      @click="onClickToggle"
    >
      <slot name="header" />
      <v-spacer />
      <v-toolbar-items>
        <slot name="icons" />
        <v-btn
          v-if="collapsible"
          icon
        >
          <v-icon>
            {{ action }}
          </v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card
      v-if="showChildren || !collapsible"
      :class="`border ${noPadding ? 'noBoxShadow': 'pa-4'}`"
    >
      <slot name="content" />
    </v-card>
  </div>
</template>

<script>
export default {
    props: {
        openedBox: {
            type: Object,
            default: () => {},
        },
        openingIcon: {
            type: String,
            default: 'mdi-pencil-outline',
        },
        closingIcon: {
            type: String,
            default: 'mdi-close',
        },
        collapsible: {
            type: Boolean,
            default: false,
        },
        customClass: {
            type: String,
            default: '',
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        containerClass: {
            type: String,
            default: '',
        },
        collapseExpandAll: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showChildren: false,
        };
    },
    computed: {
        action() {
            return this.showChildren ? this.closingIcon : this.openingIcon;
        },
    },
    watch: {
        collapseExpandAll: {
            handler() {
                if (this.collapseExpandAll === 'expandAll') {
                    this.showChildren = true;
                }
                if (this.collapseExpandAll === 'collapseAll') {
                    this.showChildren = false;
                }
            },
        },
    },
    methods: {
        onClickToggle() {
            if (this.collapsible) {
                this.showChildren = !this.showChildren;
                this.$emit('onBoxToggle', { openedBox: this.openedBox, boxIsOpen: this.showChildren });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.noBoxShadow{
    ::v-deep .v-card{
        box-shadow: none;
    }
    ::v-deep .border{
        border: none !important;
    }
}
</style>
